// components/Footer.js
import React from "react";
import './CSS/Footer.css'


const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Ali Darbar</h3>
            <p>
              Experience royal Mughlai cuisine in an ambiance of elegance and
              tradition. Our passion for authentic flavors is reflected in every
              dish we serve.
            </p>
            <div className="social-links">
              <a
                href="https://www.facebook.com/share/1B5b3MwJpf/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/alidarbar.in?igsh=azR2bnNiZmg0a293"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://x.com/AliDarbarIn?t=sHvZhHsD7WzFc2q1jS_w5w&s=09"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a
                href="https://www.youtube.com/@AliDarbar_In"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-youtube"></i>
              </a>

              <a
                href="https://www.snapchat.com/add/alidarbar.in?share_id=rGW2nJldfxk&locale=en-GB"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-snapchat"></i>
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#menu">Menu</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <i className="fas fa-phone"></i> 7030808095 <br />
                <i className="fas fa-phone"></i> 7030808025
              </li>
              <li>
                <i className="fas fa-envelope"></i> alidarbar.inn@gmail.com
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i> Shop no. 2 parampujya
                Ravishankarji marg, madina nagar, wadala, beside Madina lawns,
                opposite Bharat petroleum, nashik, maharashta - 422006.
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Ali Darbar. All rights reserved.
            Created & Maneged By{" "}
            <a href="https://faizanqureshi.netlify.app">Faizan Qureshi</a>
          </p>
          <button className="scroll-to-top" onClick={scrollToTop}>
            <i className="fas fa-chevron-up"></i>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
